export const EM_DASH = "—";
export const NO_END_LABEL = "No end";
export const NO_TASKS_MESSAGE = "Task history is not available yet.";
export const REQUEUE_BUTTON_COLOR = "#6C5DD3";
export const ALL_FILTER_VALUE = "ALL";

/** "daily" -> "Daily"; a non-repeating schedule renders as null, not the word "none". */
export const NONE_REPEATS = "none";

/** Sentinel the backend sends instead of a real timestamp for a task queued against the schedule's next tick. */
export const NEXT_TICK = "NEXT_TICK";

/** Absorbs normal enqueue/scheduling jitter around a cadence tick before treating it as missed. */
export const STALLED_GRACE_MINUTES = 15;

/** Matches the paginated table's former poll cadence so the KPI cards refresh at the same rate. */
export const SCHEDULE_POLL_INTERVAL_MS = 60_000;

/**
 * Each schedule costs 6 concurrent requests (one per task status). Batching keeps peak
 * concurrency bounded regardless of how many schedules are being resolved.
 */
export const SCHEDULE_TASK_BATCH_SIZE = 4;

export const ERROR_LOADING_ALL_SCHEDULES = "Something went wrong loading all schedules. Please try again.";
export const ERROR_LOADING_TASK_STATUS =
    "Something went wrong loading task status for one or more schedules.";
export const ERROR_LOADING_TASK_HISTORY = "Something went wrong loading task history. Please try again.";
export const TASK_QUEUED_FOR_RETRY = "Task queued for retry.";
export const SCHEDULE_ID_COPIED = "Schedule ID copied to clipboard.";
